import TaxiCorporationFleetPartnerListResponse, {
  TaxiCorporationFleetPartnerListResponseItem,
} from "../../../../api/raily/taxi-corporation/fleet-partner/list/taxi-corporation-fleet-partner-list.response";
import TaxiCorporationFleetPartnerList, {
  TaxiCorporationFleetPartnerListItem,
} from "./taxi-corporation-fleet-partner-list";

const createDataItem = (
  responseDataItem: TaxiCorporationFleetPartnerListResponseItem,
): TaxiCorporationFleetPartnerListItem => {
  return {
    creationDate: responseDataItem.createdAt,
    uuid: responseDataItem.id,
    name: responseDataItem.name,
    notes: responseDataItem.notes,
  };
};

const createData = (
  responseData: TaxiCorporationFleetPartnerListResponseItem[],
): TaxiCorporationFleetPartnerListItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: TaxiCorporationFleetPartnerListResponse,
): TaxiCorporationFleetPartnerList => {
  return createData(response.data);
};

const taxiCorporationFleetPartnerListFactory = {
  create,
};

export default taxiCorporationFleetPartnerListFactory;
